export default () => ({
  lastScrollY: 0,
  isVisible: false,
  isAtTop: false,
  isReady: false,
  threshold: 80,
  ticking: false,

  init() {
    this.isReady = false;
    this.isVisible = false;
    this.isAtTop = false;

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setTimeout(() => {
          this.lastScrollY = window.scrollY;
          this.updateState(true);
          this.isReady = true;
        }, 120);
      });
    });

    window.addEventListener(
      'scroll',
      () => {
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.updateState();
            this.ticking = false;
          });

          this.ticking = true;
        }
      },
      { passive: true },
    );
  },

  updateState(isInitial = false) {
    const currentScrollY = window.scrollY;
    const scrollingUp = currentScrollY < this.lastScrollY;

    this.isAtTop = currentScrollY <= 8;

    if (this.isAtTop) {
      this.isVisible = true;
    } else if (isInitial) {
      this.isVisible = false;
    } else if (currentScrollY > this.threshold && scrollingUp) {
      this.isVisible = true;
    } else if (currentScrollY > this.threshold && !scrollingUp) {
      this.isVisible = false;
    }

    this.lastScrollY = currentScrollY;
  },
});
